import React from 'react';
import { motion } from 'framer-motion';
const bentoItems = [{
  id: 1,
  img: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069&auto=format&fit=crop',
  title: 'Tech Vision 2024',
  category: 'Конференція',
  className: 'md:col-span-2 md:row-span-2'
}, {
  id: 2,
  img: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=2070&auto=format&fit=crop',
  title: 'Noir Gala',
  category: 'Гала-вечеря',
  className: 'md:col-span-2 md:row-span-1'
}, {
  id: 3,
  img: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=2070&auto=format&fit=crop',
  title: 'Aura Launch',
  category: 'Бренд-активація',
  className: 'md:col-span-1 md:row-span-1'
}, {
  id: 4,
  img: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2069&auto=format&fit=crop',
  title: 'Private Genesis',
  category: 'Весілля',
  className: 'md:col-span-1 md:row-span-1'
}];
export function Portfolio() {
  return <section id="portfolio" className="py-24 bg-surface" data-id="element-123">
      <div className="max-w-7xl mx-auto px-6" data-id="element-124">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-125">
          <div data-id="element-126">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-127">
              Вибрані кейси
            </h2>
            <p className="text-secondary max-w-md" data-id="element-128">
              Досліджуйте наші проекти через призму концептуального дизайну та
              бездоганної реалізації.
            </p>
          </div>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[250px] md:auto-rows-[300px] gap-4 md:gap-6" data-id="element-129">
          {bentoItems.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`group relative overflow-hidden rounded-3xl bg-background cursor-pointer border border-border ${item.className}`} data-id="element-130">
              <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-80 group-hover:opacity-100" data-id="element-131" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-100 flex flex-col justify-end p-8" data-id="element-132">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-133">
                  <p className="text-white/70 text-sm font-medium mb-2 uppercase tracking-wider" data-id="element-134">
                    {item.category}
                  </p>
                  <h3 className="text-white font-semibold text-2xl md:text-3xl" data-id="element-135">
                    {item.title}
                  </h3>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}